// extracted by mini-css-extract-plugin
export default {"button":"Sound_button__ImjMl","sound":"Sound_sound__L75yz"};